export default "__VITE_ASSET__BMsJ3iaU__"